import styles from "./StatisticsOrderDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { useNavigate } from "react-router-dom";
import { constructCashdeskHref } from "../../../common/infrastructure/routes/routePaths";
import { PriceDisplay } from "../../../common/components/PriceDisplay/PriceDisplay";
import { humanizePaymentType } from "../../../common/utilities/paymentUtility";

interface IStatisticsOrderDialogProps {
  item: IStatisticDetailedItemViewModel;
}

export const StatisticsOrderDialog = ({
  item,
}: IStatisticsOrderDialogProps) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(constructCashdeskHref({ orderId: item.id }));
  };

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName}{" "}
            {item.userId > 0 && <span>(#{item.userId})</span>}
          </h5>
          <p>
            Дата: <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
        <div className={styles.root_header_right}>{item.name}</div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"ОБЩО"}
          value={
            item.pricePaid != null ? (
              <PriceDisplay minPrice={item.pricePaid} />
            ) : (
              "—"
            )
          }
        />
        <StatisticsDialogKeyValueItem
          name={"НАЧИН НА ПЛАЩАНЕ"}
          value={humanizePaymentType(item.paymentType) ?? "—"}
        />
        <StatisticsDialogKeyValueItem
          name={"КАСИЕР"}
          value={item.additionalTypeInfo ?? "—"}
        />
      </div>
    </div>
  );
};
